export const DEFAULT_EFFECTIVE_END_DATE = new Date('2099/12/31');
export const DEFAULT_SUSPENSION_DATE = new Date('2099/12/31');
